import React from "react";
import styled from "@emotion/styled";
import Logo from "./Logo";
import useWindowSize from "../hooks/useWindowSize";
import { breakpoints } from "../hooks/useBreakpoint";
import LogoMobile from "./LogoMobile";
import Banner from "./Banner";

const Wrapper = styled.div`
  grid-area: header;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;

  & svg {
    width: 100%;
  }
`;

const Header = () => {
  const { width } = useWindowSize();

  return (
    <Wrapper>
      <Banner />
      {width >= breakpoints.sm && <Logo />}
      {width < breakpoints.sm && <LogoMobile />}
    </Wrapper>
  );
};

export default Header;
